/*
© 2026 Silhouette Systems™
Licensed Shopify Theme Components & Features
All rights reserved.
*/

const Wishlist = {
  init() {
    this.items = JSON.parse(localStorage.getItem('wishlist')) || [];
    this.updateHeaderCount();
    this.bindEvents();
  },

  save() {
    localStorage.setItem('wishlist', JSON.stringify(this.items));
    this.updateHeaderCount();
  },

  toggle(item) {
    const exists = this.items.find(i => i.id === item.id);
    if (exists) {
      this.items = this.items.filter(i => i.id !== item.id);
    } else {
      this.items.push(item);
    }
    this.save();
    return !exists;
  },

  updateHeaderCount() {
    const el = document.querySelector('.wishlist-count');
    if (!el) return;
    el.textContent = this.items.length;
    el.style.display = this.items.length ? 'block' : 'none';
  },

  bindEvents() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.wishlist-btn');
      if (!btn) return;

      e.preventDefault();
      const active = this.toggle({
        id: btn.dataset.productId,
        title: btn.dataset.productTitle,
        url: btn.dataset.productUrl,
        image: btn.dataset.productImage,
        price: btn.dataset.productPrice
      });

      btn.classList.toggle('active', active);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => Wishlist.init());